import { render, staticRenderFns } from "./LoadingItem.vue?vue&type=template&id=2aee2dc0&scoped=true&"
import script from "./LoadingItem.vue?vue&type=script&lang=ts&"
export * from "./LoadingItem.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingItem.vue?vue&type=style&index=0&id=2aee2dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee2dc0",
  null
  
)

export default component.exports